module.exports = __webpack_public_path__ + "static/icons/icon-x-873ab17d4e9645c57361d8ee600943eb.svg";